import H from 'highcharts'
//TODO improve handling of highcharts

export default {
  presetEvents: {
    afterMerge(H, options) {
      const [actual] = options.series
      actual.visible = false
      actual.name = actual.name || 'Ist'
    },

    chartEvents: {
      render() {
        const layout = this.plotHeight * 1.5 > this.plotWidth ? 'portriat' : 'landscape'

        const style = { //TODO use the label style from somewhere
          fontSize: '16px',
          fontWight: 'bold',
          color: '#666666'
        }

        let [actual, target] = this.series
        let redraw = false
        if (!target) {
          redraw = true
          const targetData = actual.options.data
            .filter(data => data.y || data.target)
            .map(data => {
              const key = data.id + '_target'
              data.linkTo = key
              data.source = data.y
              return {
                ...data,
                id: key,
                y: data.target,
                linkTo: data.id
              }
            })

          this.addSeries({
            showInLegend: true,
            name: actual.userOptions.target || 'Soll',
            data: targetData,
            center: layout === 'landscape' ? ["80%", null] : [null, "80%"]
          }, false)

          target = this.series[1]
        }

        const layoutChanged = this.layout !== layout || redraw
        this.layout = layout

        if (this.text1) {
          this.text1.destroy()
          this.text1 = undefined
        }

        if (this.text2) {
          this.text2.destroy()
          this.text2 = undefined
        }
        //TODO better position calculations
        const pieHight = this.plotHeight / 100 * 40
        if (layout === 'landscape') {
          this.text1 = this.renderer.text(actual.name, this.plotWidth / 100 * 20 + 15, this.plotHeight / 2 + 10).css(style).add()
          this.text2 = this.renderer.text(target.name, this.plotWidth / 100 * 80 - 15, this.plotHeight / 2 + 10).css(style).add()
        } else {
          this.text1 = this.renderer.text(actual.name, this.plotWidth / 2, this.plotHeight / 100 * 15 + pieHight / 2 - 16 / 2).css(style).add()
          this.text2 = this.renderer.text(target.name, this.plotWidth / 2 - 5, this.plotHeight / 100 * 65 + pieHight / 2 - 16 / 2).css(style).add()
        }

        if (layoutChanged) {
          redraw = true
          if (layout === 'landscape') {
            actual.update({visible: true, center: ["20%", null]}, false)
            target.update({center: ["80%", null]}, false)
          } else {
            actual.update({visible: true, center: [null, "20%"]}, false)
            target.update({center: [null, "80%"]}, false)
          }
        }

        if (redraw) {
          this.redraw()
        }


      }
    }
  },

  chart: {
    type: "pie",
    height: 300,
  },

  plotOptions: {
    pie: {
      dataLabels: {
        formatter: function () {
          if (this.y > 0) {
            return H.numberFormat(this.point.percentage, 1) + '%'
          }
        },
        distance: '5%'
      },
      innerSize: "60%",
      size: '40%',
    },
  },

  tooltip: {
    pointFormatter() {
      const {source, target} = this.options
      const [actualSeries, targetSeries] = this.series.chart.series
      const sourceTitle = actualSeries.name || 'Ist'
      const targetTitle = targetSeries.name || 'Soll'

      return `${sourceTitle}: ${H.numberFormat(source, 1) + '%'}<br />${targetTitle}: ${H.numberFormat(target, 1) + '%'}`
    }
  },

  series: [{
    innerSize: "50%",
  }]
}
